// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const TentativeTimeIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'tentative-time'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M21.9498 11C22.0181 11.6776 22.0169 12.3604 21.9464 13.0377M2.05032 13.0391C1.98209 12.3615 1.98325 11.6787 2.05379 11.0013M19.7567 18.3345C19.3258 18.8619 18.8422 19.3438 18.3133 19.7729M4.24372 5.70456C4.6746 5.17719 5.15823 4.6952 5.68707 4.26612M13.0196 21.9683C12.342 22.0365 11.6592 22.0354 10.9819 21.9648M10.9805 2.07073C11.6581 2.0025 12.3409 2.00367 13.0183 2.07421M5.68537 19.7759C5.15799 19.345 4.67601 18.8614 4.24693 18.3325M18.3146 4.26316C18.8419 4.69404 19.3239 5.17767 19.753 5.70651M12.0001 5.99999V12L16.0001 14"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
TentativeTimeIcon.displayName = 'TentativeTimeIcon'
export { TentativeTimeIcon }
